import { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { connectorsApi } from '../../services/connectorsApi';
import useWorkspaceStore from '../../store/workspace/workspaceStore';

export function ReconnectBanner() {
  const workspace = useWorkspaceStore((s) => s.workspace);
  const workspaceId = workspace?.id;
  const workspaceSlug = workspace?.unique_identifier;
  const [needsReconnect, setNeedsReconnect] = useState<string[]>([]);

  useEffect(() => {
    if (!workspaceId) return;
    connectorsApi
      .getMine(workspaceId)
      .then((r: any) =>
        setNeedsReconnect(
          (r?.data?.connected ?? [])
            .filter((c: any) => c.reconnect_needed)
            .map((c: any) => c.provider as string),
        ),
      )
      .catch(() => setNeedsReconnect([]));
  }, [workspaceId]);

  if (needsReconnect.length === 0) return null;

  const settingsPath = workspaceSlug
    ? `/home/${workspaceSlug}/settings/integrations`
    : '/settings/integrations';

  return (
    <div className="flex items-center gap-2 border-b border-status-in-progress/20 bg-status-in-progress/[0.08] px-4 py-2 text-[12px] text-foreground">
      <AlertTriangle
        size={14}
        className="flex-shrink-0 text-status-in-progress"
        aria-hidden="true"
      />
      <span>
        <span className="font-medium">{needsReconnect.join(', ')}</span>{' '}
        {needsReconnect.length === 1 ? 'needs' : 'need'} reconnection.{' '}
        <Link
          to={settingsPath}
          className="font-medium underline underline-offset-2 hover:text-status-in-progress"
        >
          Reconnect
        </Link>
      </span>
    </div>
  );
}
